import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbsModule } from '../../../../@fury/shared/breadcrumbs/breadcrumbs.module';
import { MaterialModule } from '../../../../@fury/shared/material-components.module';
import { IndexRoutingModule } from './index-routing.module';
import { IndexComponent } from './index.component';
import { FurySharedModule } from '../../../../@fury/fury-shared.module';
import { LoadingOverlayModule } from '../../../../@fury/shared/loading-overlay/loading-overlay.module';
import { BackdropModule } from '../../../../@fury/shared/backdrop/backdrop.module';
import { QuillModule } from 'ngx-quill';
import { TableFiltersModule } from '../../../../@fury/shared/table-filters/table-filters/table-filters.module';
import { ScrollbarModule } from '../../../../@fury/shared/scrollbar/scrollbar.module';
import { ReportsFiltersComponent } from './filters/filters.component';
import { MatCalendarWithPresetsModule } from '../../../../@fury/shared/calendar/presets/presets.module';
import { FurySharedDateModule } from '../../../../@fury/fury-shared-date.module';
import { MatPaginationGoToPageDirective } from '../../../../@fury/shared/mat-pagination-go-to-page/mat-pagination-go-to-page.directive';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';

@NgModule({
  imports: [
    CommonModule,
    IndexRoutingModule,
    FormsModule,
    MaterialModule,
    FurySharedModule,
    QuillModule,
    FurySharedDateModule,

    // Core
    BreadcrumbsModule,
    LoadingOverlayModule,
    BackdropModule,
    ReactiveFormsModule,
    TableFiltersModule,
    ScrollbarModule,
    MatCalendarWithPresetsModule,
    MatPaginationGoToPageDirective,
    MtxDatetimepickerModule,
  ],
  declarations: [
    IndexComponent,
    ReportsFiltersComponent,
  ],
  exports: [
    IndexComponent,
    ReportsFiltersComponent,
  ],
  providers: [
  ]
})
export class IndexModule {
}
